import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

/** Overflow-driven abbreviation for the compact stats bars. Render the real (possibly animated) row
 * on `containerRef` (width:100%, so its clientWidth is the available cell width) and a hidden,
 * static, full-value copy on `measureRef`. `abbreviate` flips true only when the full copy is wider
 * than the container, so full numbers show whenever they fit and abbreviate only when they'd be cut
 * off. Measuring the static copy (not the animated row) avoids oscillation and animation skew.
 * `measureKey` should change with the values / label mode so the check re-runs. */
const useAbbreviateOnOverflow = (measureKey) => {
  const containerRef = useRef(null);
  const measureRef = useRef(null);
  const [abbreviate, setAbbreviate] = useState(false);
  useEffect(() => {
    const c = containerRef.current;
    const m = measureRef.current;
    if (!c || !m) return undefined;
    const check = () => setAbbreviate(m.offsetWidth > c.clientWidth);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(c);
    return () => ro.disconnect();
  }, [measureKey]);
  return { containerRef, measureRef, abbreviate };
};

export default useAbbreviateOnOverflow;
